// src/components/Header.jsx
import { useEffect, useMemo, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { getWhatsAppLink } from "./whatsapp/getWhatsAppLink";

function Header() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const waLink = getWhatsAppLink(location.pathname);

  const navItems = useMemo(
    () => [
      { to: "/", label: "Home" },
      { to: "/cenografia", label: "Cenografia" },
      { to: "/iluminacao", label: "Iluminação" },
      { to: "/portfolio", label: "Portfólio" },
      { to: "/contato", label: "Contato" },
    ],
    []
  );

  /* Fecha menu ao trocar rota */
  useEffect(() => {
    setIsOpen(false);
  }, [location.pathname]);

  /* Trava scroll + ESC */
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";

    const onKey = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };

    if (isOpen) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen]);

  return (
    <header>
      <div className="header-container">
        {/* LOGO */}
        <Link to="/" className="logo" aria-label="Ir para Home">
          <img
            src="/images/logo/cenovix-logo.png"
            alt="Cenovix - Cenografia e Iluminação Cênica"
            className="logo-image"
          />
        </Link>

        {/* NAV DESKTOP */}
        <nav className="nav-desktop" aria-label="Navegação principal">
          {navItems.map((item) => (
            <Link key={item.to} to={item.to}>
              {item.label}
            </Link>
          ))}
        </nav>

        {/* CTA WHATSAPP */}
        <a
          href={waLink}
          target="_blank"
          rel="noopener noreferrer"
          className="header-cta header-cta--always"
          aria-label="Falar no WhatsApp"
        >
          Falar no WhatsApp
        </a>

        {/* HAMBURGER */}
        <button
          type="button"
          className="hamburger"
          aria-label={isOpen ? "Fechar menu" : "Abrir menu"}
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
          onClick={() => setIsOpen((v) => !v)}
        >
          <span className="hamburger-line" />
          <span className="hamburger-line" />
          <span className="hamburger-line" />
        </button>
      </div>

      {/* MENU MOBILE */}
      <div
        className={`mobile-menu ${isOpen ? "is-open" : ""}`}
        onClick={() => setIsOpen(false)}
      >
        <div
          className="mobile-menu__panel"
          id="mobile-menu"
          role="dialog"
          aria-modal="true"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="mobile-menu__top">
            <span className="mobile-menu__title">Menu</span>

            <button
              type="button"
              className="mobile-menu__close"
              aria-label="Fechar menu"
              onClick={() => setIsOpen(false)}
            >
              ✕
            </button>
          </div>

          <nav className="mobile-menu__nav" aria-label="Navegação mobile">
            {navItems.map((item) => (
              <Link key={item.to} to={item.to} className="mobile-menu__link">
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
